module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Ingenico","payTtl":"Proveedor de sercicios de pago para tiendas online, pagos móviles y pagos en el punto de venta.","payText":" ","payBtn":"MÁS INFORMACIÓN"},"es":{"payTitulo":"Ingenico","payTtl":"Proveedor de sercicios de pago para tiendas online, pagos móviles y pagos en el punto de venta.","payText":" ","payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
